module.exports = __webpack_public_path__ + "img/shimen-1.cfea31f4.jpg";